import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Loader } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { fields, fieldsReady } from "../constantsdum";
import { Language, NextPageKey, useOurPolicies } from "../Corporate.hook";
import { OurPoliciesPageHeading } from "./OurPoliciesPageHeading";
export type LanguageContentField = "field_content_english" | "field_content_malay" | "field_content_mandarin";
export function toCamelCase(str: string) {
  if (!str) return "";

  // 1. Remove all special characters except letters, numbers, and hyphens
  const cleaned = str.replace(/[^a-zA-Z0-9\- ]+/g, "");

  // 2. Replace spaces with hyphens so camelCase rule applies consistently
  const normalized = cleaned.replace(/\s+/g, "-");

  // 3. Apply camelCase transformation
  return normalized.replace(/-([a-zA-Z0-9])/g, (_, chr) => chr.toUpperCase());
}

export function toPascalCase(str: string) {
  return str?.replace(/(^\w|-\w)/g, (match) => match?.replace("-", "")?.toUpperCase());
}

export const OurPoliciesDynamic: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const [fieldData, setFieldData] = useState<any>();
  const [payloadData, setPayloadData] = useState<any>();

  const { data: policiesData, isLoading: isLoadingpolicies, refetch: refetchOurPolicies } = useOurPolicies();
  const {
    data: policiesDataById,
    isLoading: isLoadingpoliciesById,
    refetch: refetchOurPoliciesById,
  } = useDocumentDetails(query?.get("id") || "");

  console.log("set datas", fieldData, payloadData, policiesData, policiesDataById);

  useEffect(() => {
    if (query?.get("id")) {
      setPayloadData(policiesDataById?.payload);
    } else {
      setPayloadData(policiesData?.[0]);
    }
  }, [policiesData, policiesDataById]);

  useEffect(() => {
    if (approveId) {
      return;
    }
    const thirdChildActiveTab = query.get("thirdSubActiveTab");
    if (query.get("activeTab") === "ourPolicies" && query.get("subActiveTab") === "malaysiaAirportsHoldingsBerhad") {
      navigate(
        `/dedicated/corporate/corporate-profile?activeTab=ourPolicies&subActiveTab=malaysiaAirportsHoldingsBerhad&thirdSubActiveTab=${
          thirdChildActiveTab ?? "codeOfEthicsForMalaysiaAirportsHoldingsBerhad_0"
        }`,
        {
          replace: true,
        }
      );
    }
    if (query.get("activeTab") === "ourPolicies" && query.get("subActiveTab") === "subsidiaries") {
      navigate(
        `/dedicated/corporate/corporate-profile?activeTab=ourPolicies&subActiveTab=subsidiaries&thirdSubActiveTab=${
          thirdChildActiveTab ?? "codeOfEthicsForSubsidiaries_0"
        }`,
        {
          replace: true,
        }
      );
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);

  useEffect(() => {
    if (approveId) {
      refetchOurPoliciesById();
    } else {
      refetchOurPolicies();
    }
  }, [query.get("subActiveTab"), query.get("thirdSubActiveTab"), approveId]);

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const NextPageFormConfig: FormConfig = {
    initialValues: {
      "field_content_english.data.nextPage.name": (() => {
        try {
          if (policiesDataById?.payload?.field_content_english) {
            const parsed = JSON.parse(policiesDataById.payload.field_content_english);
            return decodeHTML(parsed?.data?.nextPage?.name);
          }
          return decodeHTML(policiesData?.[0]?.field_content_english?.data?.nextPage?.name) || "";
        } catch (error) {
          console.error("Error parsing English nextPage name:", error);
          return decodeHTML(policiesData?.[0]?.field_content_english?.data?.nextPage?.name) || "";
        }
      })(),

      "field_content_english.data.nextPage.link": (() => {
        try {
          if (policiesDataById?.payload?.field_content_english) {
            const parsed = JSON.parse(policiesDataById.payload.field_content_english);
            return decodeHTML(parsed?.data?.nextPage?.link);
          }
          return decodeHTML(policiesData?.[0]?.field_content_english?.data?.nextPage?.link) || "";
        } catch (error) {
          console.error("Error parsing English nextPage link:", error);
          return decodeHTML(policiesData?.[0]?.field_content_english?.data?.nextPage?.link) || "";
        }
      })(),

      "field_content_malay.data.nextPage.name": (() => {
        try {
          if (policiesDataById?.payload?.field_content_malay) {
            const parsed = JSON.parse(policiesDataById.payload.field_content_malay);
            return decodeHTML(parsed?.data?.nextPage?.name);
          }
          return decodeHTML(policiesData?.[0]?.field_content_malay?.data?.nextPage?.name) || "";
        } catch (error) {
          console.error("Error parsing Malay nextPage name:", error);
          return decodeHTML(policiesData?.[0]?.field_content_malay?.data?.nextPage?.name) || "";
        }
      })(),

      "field_content_malay.data.nextPage.link": (() => {
        try {
          if (policiesDataById?.payload?.field_content_malay) {
            const parsed = JSON.parse(policiesDataById.payload.field_content_malay);
            return decodeHTML(parsed?.data?.nextPage?.link);
          }
          return decodeHTML(policiesData?.[0]?.field_content_malay?.data?.nextPage?.link) || "";
        } catch (error) {
          console.error("Error parsing Malay nextPage link:", error);
          return decodeHTML(policiesData?.[0]?.field_content_malay?.data?.nextPage?.link) || "";
        }
      })(),

      "field_content_mandarin.data.nextPage.name": (() => {
        try {
          if (policiesDataById?.payload?.field_content_mandarin) {
            const parsed = JSON.parse(policiesDataById.payload.field_content_mandarin);
            return decodeHTML(parsed?.data?.nextPage?.name);
          }
          return decodeHTML(policiesData?.[0]?.field_content_mandarin?.data?.nextPage?.name) || "";
        } catch (error) {
          console.error("Error parsing Mandarin nextPage name:", error);
          return decodeHTML(policiesData?.[0]?.field_content_mandarin?.data?.nextPage?.name) || "";
        }
      })(),

      "field_content_mandarin.data.nextPage.link": (() => {
        try {
          if (policiesDataById?.payload?.field_content_mandarin) {
            const parsed = JSON.parse(policiesDataById.payload.field_content_mandarin);
            return decodeHTML(parsed?.data?.nextPage?.link);
          }
          return decodeHTML(policiesData?.[0]?.field_content_mandarin?.data?.nextPage?.link) || "";
        } catch (error) {
          console.error("Error parsing Mandarin nextPage link:", error);
          return decodeHTML(policiesData?.[0]?.field_content_mandarin?.data?.nextPage?.link) || "";
        }
      })(),
    },
    fields: fields?.nextPageOurPolicies,
  };

  // const NextPageFormConfig: FormConfig = {
  //   initialValues: {
  //     [`field_content_english.data.nextPage.name`]:
  //       policiesDataById?.payload
  //         ? decodeHTML(JSON.parse(policiesDataById?.payload?.field_content_english)?.data?.nextPage?.name)
  //         : decodeHTML(policiesData?.[0]?.field_content_english?.data?.nextPage?.name),

  //     [`field_content_english.data.nextPage.link`]:
  //         policiesDataById?.payload
  //           ? decodeHTML(JSON.parse(policiesDataById?.payload?.field_content_english)?.data?.nextPage?.link)
  //           : decodeHTML(policiesData?.[0]?.field_content_english?.data?.nextPage?.link),
  //     [`field_content_malay.data.nextPage.name`]:
  //         policiesDataById?.payload
  //           ? decodeHTML(JSON.parse(policiesDataById?.payload?.field_content_malay)?.data?.nextPage?.name)
  //           : decodeHTML(policiesData?.[0]?.field_content_malay?.data?.nextPage?.name),
  //     [`field_content_malay.data.nextPage.link`]:
  //         policiesDataById?.payload
  //           ? decodeHTML(JSON.parse(policiesDataById?.payload?.field_content_malay)?.data?.nextPage?.link)
  //           : decodeHTML(policiesData?.[0]?.field_content_malay?.data?.nextPage?.link),
  //     [`field_content_mandarin.data.nextPage.name`]:
  //           policiesDataById?.payload
  //             ? decodeHTML(JSON.parse(policiesDataById?.payload?.field_content_mandarin)?.data?.nextPage?.name)
  //             : decodeHTML(policiesData?.[0]?.field_content_mandarin?.data?.nextPage?.name),
  //     [`field_content_mandarin.data.nextPage.link`]:
  //           policiesDataById?.payload
  //             ? decodeHTML(JSON.parse(policiesDataById?.payload?.field_content_mandarin)?.data?.nextPage?.link)
  //             : decodeHTML(policiesData?.[0]?.field_content_mandarin?.data?.nextPage?.link),
  //   },
  //   fields: fieldData?.nextPageOurPolicies,
  // };
  const createFormConfig = (name?: string, idx1?: any, idx2?: any, field?: any): FormConfig => {
    const getMarkupValue = (language: Language) => {
      const payload = policiesDataById?.payload?.[language];

      if (!isLoadingpoliciesById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.markup);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.markup);
        }
      }

      return decodeHTML(policiesData?.[0]?.[language]?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.markup);
    };
    const getTitleValue = (language: Language) => {
      const payload = policiesDataById?.payload?.[language];
      if (!isLoadingpoliciesById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.title || "");
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.title || "");
        }
      }
      return decodeHTML(policiesData?.[0]?.[language]?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.title || "");
    };

    const getNextPageValue = (language: Language, key: NextPageKey) => {
      const payload = policiesDataById?.payload?.[language];
      if (!isLoadingpoliciesById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.nextPage?.[key]);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.nextPage?.[key]);
        }
      }
      return decodeHTML(policiesData?.[0]?.[language]?.data?.nextPage?.[key]);
    };

    return {
      initialValues: {
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].title`]:
          getTitleValue("field_content_english"),
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].markup`]:
          getMarkupValue("field_content_english"),
        // [`field_content_english.data.nextPage.name`]: getNextPageValue("field_content_english", "name"),
        // [`field_content_english.data.nextPage.link`]: getNextPageValue("field_content_english", "link"),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].title`]: getTitleValue("field_content_malay"),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].markup`]:
          getMarkupValue("field_content_malay"),
        // [`field_content_malay.data.nextPage.name`]: getNextPageValue("field_content_malay", "name"),
        // [`field_content_malay.data.nextPage.link`]: getNextPageValue("field_content_malay", "link"),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].title`]:
          getTitleValue("field_content_mandarin"),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].markup`]:
          getMarkupValue("field_content_mandarin"),
        // [`field_content_mandarin.data.nextPage.name`]: getNextPageValue("field_content_mandarin", "name"),
        // [`field_content_mandarin.data.nextPage.link`]: getNextPageValue("field_content_mandarin", "link"),
      },
      fields: field,
    };
  };

  const updatePayload = (data: any) => {
    console.log("updatePayload", data, payloadData);

    const convertDotNotation = (obj: any): any => {
      const result: any = {};
      for (const key in obj) {
        if (key.includes(".")) {
          const parts = key.split(".");
          let current = result;
          for (let i = 0; i < parts.length - 1; i++) {
            current[parts[i]] = current[parts[i]] || {};
            current = current[parts[i]];
          }
          current[parts[parts.length - 1]] = obj[key];
        } else {
          result[key] = obj[key];
        }
      }
      return result;
    };

    const filterNestedObjects = (obj: any): any => {
      const result: any = {};
      for (const key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          if (Array.isArray(obj[key])) {
            result[key] = obj[key];
          } else {
            result[key] = filterNestedObjects(obj[key]);
          }
        } else {
          result[key] = obj[key];
        }
      }
      return result;
    };

    const replacePayload = (target: any, source: any) => {
      for (const key in source) {
        if (
          source[key] === null ||
          source[key] === undefined ||
          (typeof source[key] === "object" && !Object.keys(source[key]).length)
        ) {
          continue;
        }
        if (source[key] instanceof Object && target[key]) {
          replacePayload(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    };

    const parseIfJson = (value: any) => {
      if (typeof value === "string") {
        try {
          return JSON.parse(value);
        } catch {
          return value; // Return as is if not valid JSON
        }
      }
      return value;
    };

    const parsedPayloadData = { ...payloadData };
    ["field_content_english", "field_content_malay", "field_content_mandarin"].forEach((field) => {
      if (parsedPayloadData[field]) {
        parsedPayloadData[field] = parseIfJson(parsedPayloadData[field]);
      }
    });

    const convertedData = convertDotNotation(data);
    console.log("convertedData", convertedData, data);

    const filteredData = filterNestedObjects(convertedData);
    console.log("Data for...", data, filteredData);

    const payload = { ...parsedPayloadData };
    console.log("payload data", payload);

    replacePayload(payload, filteredData);
    console.log("finaldata", data, payload);

    ["field_content_english", "field_content_malay", "field_content_mandarin"].forEach((field) => {
      if (payload[field]) {
        payload[field] = JSON.stringify(payload[field]);
      }
    });

    return payload;
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    const payloadData = await updatePayload(data);
    const activeTab = query?.get("activeTab") || "ourPolicies";
    const subActiveTab = query?.get("subActiveTab") || "";
    const thirdSubActiveTab = query?.get("thirdSubActiveTab") || "";
    let computedSubModule = `${activeTab}_${subActiveTab}${thirdSubActiveTab ? `_${thirdSubActiveTab}` : ""}`;
    if (thirdSubActiveTab && subActiveTab && thirdSubActiveTab !== "nextPage") {
      try {
        const match = thirdSubActiveTab.match(/For(MalaysiaAirportsHoldingsBerhad|Subsidiaries)_(\d+)$/);
        const idx1 = match ? parseInt(match[2], 10) : undefined;
        const tabType = match ? match[1] : undefined;
        const englishJson = payloadData?.field_content_english
          ? JSON.parse(payloadData.field_content_english)
          : undefined;
        const tabIndexMap: { [key: string]: number } = {
          malaysiaAirportsHoldingsBerhad: 0,
          subsidiaries: 1,
        };
        const tabIndex = tabIndexMap[subActiveTab.toLowerCase()];
        const currentIndex = englishJson?.data?.items?.[tabIndex]?.tabData?.items?.[idx1 || 0]?.key;

        if (currentIndex && tabType) {
          computedSubModule = `${activeTab}_${subActiveTab}_${toCamelCase(currentIndex)}For${tabType}_${idx1}`;
        }
      } catch (e) {
        console.error("Error computing subModule:", e);
        computedSubModule = `${activeTab}_${subActiveTab}_${thirdSubActiveTab}`;
      }
    } else if (subActiveTab === "nextPage") {
      computedSubModule = `${activeTab}_nextPage`;
    }
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];

    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field && field[0]) {
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "CORPORATE");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              data[key] = res.response.data;
            }
          } else if (field[0].url) {
            data[key] = field[0].url;
          }
        }
      } catch (error) {}
    }
    let payload;
    if (query.get("activeTab") === "ourPolicies") {
      payload = {
        action: action,
        method: method,
        module: "CorporateProfile",
        subModule: computedSubModule,
        type: "DEDICATED",
        application: "MAHB_CORPORATE",
        reviewNotes: reviewNotes,
        moduleKey: "MAHB_CORPORATE_Corporate Profile_Our Policies",
        appList: [
          {
            appName: "MAHB_CORPORATE",
            apiUrl: apiUrl,
          },
        ],
        payload: payloadData,
        status: status,
      };
    }
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const generateFormItem = (label: any, key: any, config: any, API_ENDPOINT: any) => {
    return {
      label,
      key,
      children: (
        <DynamicForm
          isLoading={isLoadingpolicies || isLoadingpoliciesById}
          config={config}
          onSubmit={(data, buttonValue, reviewNotes) =>
            onSubmit(data, API_ENDPOINT, "UPDATE", "PATCH", buttonValue === "save" ? "DRAFT" : "PENDING", reviewNotes)
          }
          defaultReviewNotes="Kindly review this Corporate Profile"
        />
      ),
    };
  };

  const policiesSubChildItems1 = policiesData
    ? policiesData?.[0]?.field_content_english?.data?.items[0]?.tabData?.items
        .filter(Boolean)
        .map((item: any, index: any) => {
          const uniqueKey = `${toCamelCase(item.key)}ForMalaysiaAirportsHoldingsBerhad_${index}`;
          const pascalCaseConfigName = `${toPascalCase(item.key)}ForMalaysiaAirportsHoldingsBerhadFormConfig`;

          return generateFormItem(
            item.title,
            uniqueKey,
            createFormConfig(item.key, [0], [index], fieldData?.malaysiaAirportsHoldingsBerhadOurPolicies?.[index]),
            `${corporateHost}/api/page-content/${policiesData?.[0]?.id || policiesDataById?.payload?.id || "67"}`
          );
        })
    : (() => {
        const fieldContent = policiesDataById?.payload?.field_content_english;
        let parsedContent;

        console.log("policiesDatabyid", policiesDataById);

        // Validate and safely parse JSON
        try {
          parsedContent = fieldContent ? JSON.parse(fieldContent) : null;
          console.log("policiesDatabyid -parse", parsedContent);
        } catch (error) {
          console.error("Failed to parse field_content_english:", error);
          parsedContent = null;
        }

        return (
          parsedContent?.data?.items[0]?.tabData?.items?.filter(Boolean)?.map((item: any, index: any) => {
            console.log("policiesDatabyid --map", item);
            const uniqueKey = `${toCamelCase(item.key)}ForMalaysiaAirportsHoldingsBerhad_${index}`;
            const pascalCaseConfigName = `${toPascalCase(item.key)}ForMalaysiaAirportsHoldingsBerhadFormConfig`;

            return generateFormItem(
              item.title,
              uniqueKey,
              createFormConfig(item.key, [0], [index], fieldData?.malaysiaAirportsHoldingsBerhadOurPolicies?.[index]),
              `${corporateHost}/api/page-content/${policiesData?.[0]?.id || policiesDataById?.payload?.id || "67"}`
            );
          }) || []
        );
      })();

  const policiesSubChildItems2 = policiesData
    ? policiesData?.[0]?.field_content_english?.data?.items[1]?.tabData?.items
        .filter(Boolean)
        .map((item: any, index: any) => {
          const uniqueKey = `${toCamelCase(item.key)}ForSubsidiaries_${index}`;
          const pascalCaseConfigName = `${toPascalCase(item.key)}ForSubsidiaries`;

          return generateFormItem(
            item.title,
            uniqueKey,
            createFormConfig(item.key, [1], [index], fieldData?.subsidiariesOurPolicies?.[index]),
            `${corporateHost}/api/page-content/${policiesData?.[0]?.id || policiesDataById?.payload?.id || "67"}`
          );
        })
    : (() => {
        const fieldContent = policiesDataById?.payload?.field_content_english;
        let parsedContent;
        try {
          parsedContent = fieldContent ? JSON.parse(fieldContent) : null;
        } catch (error) {
          console.error("Failed to parse field_content_english:", error);
          parsedContent = null;
        }

        return (
          parsedContent?.data?.items[1]?.tabData?.items?.filter(Boolean)?.map((item: any, index: any) => {
            const uniqueKey = `${toCamelCase(item.key)}ForSubsidiaries_${index}`;
            const pascalCaseConfigName = `${toPascalCase(item.key)}ForSubsidiaries`;

            return generateFormItem(
              item.title,
              uniqueKey,
              createFormConfig(item.key, [1], [index], fieldData?.subsidiariesOurPolicies?.[index]),
              `${corporateHost}/api/page-content/${policiesData?.[0]?.id || policiesDataById?.payload?.id || "67"}`
            );
          }) || []
        );
      })();

  console.log("tab items", policiesSubChildItems1, policiesSubChildItems2);

  const generatePoliciesTabItem = (label: any, key: any, subChildItems: any) => ({
    label,
    key,
    children: (
      <Tabs
        activeKey={query?.get("thirdSubActiveTab") || ""}
        items={subChildItems}
        onChange={(activeKey) => {
          navigate(
            `${window.location.pathname}?activeTab=ourPolicies&subActiveTab=${key}&thirdSubActiveTab=${activeKey}`
          );
        }}
      ></Tabs>
    ),
  });

  const policiesChildItems = [
    {
      label: "Page Heading",
      key: "ourPoliciesPageHeading",
      children: <OurPoliciesPageHeading />,
    },
    generatePoliciesTabItem(
      "Malaysia Airports Holdings Berhad",
      "malaysiaAirportsHoldingsBerhad",
      policiesSubChildItems1 || []
    ),
    generatePoliciesTabItem("Subsidiaries", "subsidiaries", policiesSubChildItems2 || []),
    generateFormItem(
      "Next Page",
      "nextPage",
      NextPageFormConfig,
      `${corporateHost}/api/page-content/${policiesData?.[0]?.id || policiesDataById?.payload?.id || "67"}`
    ),
  ];

  if (isLoadingpoliciesById || isLoadingpolicies) {
    return <Loader />;
  }

  return (
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={policiesChildItems}
      onChange={(activeKey: any) => {
        navigate(`${window.location.pathname}?activeTab=ourPolicies&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
  );
};
